import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=23f76477"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports